// src/modules/accounting/pages/AccountingPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Card, Row, Col, Result, Grid } from 'antd';
import { LockOutlined, RightOutlined } from '@ant-design/icons';
import { usePermissions } from '../../../hooks/usePermissions';
import { ACCOUNTING_SECTIONS } from '../sections';

const { Title, Text, Paragraph } = Typography;
const { useBreakpoint } = Grid;

export default function AccountingPage() {
  const navigate = useNavigate();
  const { canViewField } = usePermissions();
  const screens = useBreakpoint();

  // Only show the sections this user is allowed to see.
  const visibleSections = ACCOUNTING_SECTIONS.filter((s) =>
    canViewField('accounting', s.fieldName)
  );

  if (visibleSections.length === 0) {
    return (
      <div style={{ padding: 24 }}>
        <Card>
          <Result
            status="403"
            title="Access Denied"
            subTitle="You don't have permission to view any accounting sections."
            icon={<LockOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />}
          />
        </Card>
      </div>
    );
  }

  return (
    <div style={{ padding: screens.xs ? 16 : 24 }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={3} style={{ marginBottom: 4 }}>Company Accounting</Title>
        <Text type="secondary">
          Select a section to view its reports and manage entries.
        </Text>
      </div>

      <Row gutter={[16, 16]}>
        {visibleSections.map((section) => (
          <Col key={section.key} xs={24} sm={12} lg={8} xxl={6}>
            <Card
              hoverable
              onClick={() => navigate(`/accounting/${section.path}`)}
              styles={{ body: { padding: 20 } }}
              style={{ height: '100%', borderRadius: 12 }}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                <div
                  style={{
                    flexShrink: 0,
                    width: 48,
                    height: 48,
                    borderRadius: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 22,
                    color: section.color,
                    background: `${section.color}1A`, // ~10% opacity tint
                  }}
                >
                  {section.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 8,
                    }}
                  >
                    <Text strong style={{ fontSize: 16 }}>
                      {section.title}
                    </Text>
                    <RightOutlined style={{ color: '#bfbfbf', fontSize: 12 }} />
                  </div>
                  <Paragraph
                    type="secondary"
                    style={{ margin: '6px 0 0', fontSize: 13 }}
                    ellipsis={{ rows: 2 }}
                  >
                    {section.description}
                  </Paragraph>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
